import FeaturePTSForm from '../../features/PTSForm'
import { setActivatedLanguage } from '../../app/redux/globalLanguage.Slice'
import { useAppDispatch } from '../../app/redux/hooks'

const Page = ({ defaultLanguage }: any) => {
    const dispatch = useAppDispatch()
    dispatch(setActivatedLanguage(defaultLanguage))

    return <FeaturePTSForm />
}

export default Page
